import { render, staticRenderFns } from "./BookingShow.vue?vue&type=template&id=165a5eed&scoped=true"
import script from "./BookingShow.vue?vue&type=script&lang=js"
export * from "./BookingShow.vue?vue&type=script&lang=js"
import style0 from "./BookingShow.vue?vue&type=style&index=0&id=165a5eed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165a5eed",
  null
  
)

export default component.exports